"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayDropDownWithDrilldown = void 0;
var _button = require("@clayui/button");
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _Caption = _interopRequireDefault(require("./Caption"));
var _DropDown = _interopRequireDefault(require("./DropDown"));
var _Help = _interopRequireDefault(require("./Help"));
var _Items = require("./Items");
var _Search = _interopRequireDefault(require("./Search"));
var _excluded = ["label", "title"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2020 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDropDownWithDrilldown = exports.ClayDropDownWithDrilldown = function ClayDropDownWithDrilldown(_ref) {
  var externalActive = _ref.active,
    alignmentByViewport = _ref.alignmentByViewport,
    alignmentPosition = _ref.alignmentPosition,
    caption = _ref.caption,
    className = _ref.className,
    containerElement = _ref.containerElement,
    _ref$defaultActive = _ref.defaultActive,
    defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
    footerContent = _ref.footerContent,
    helpText = _ref.helpText,
    defaultActiveMenu = _ref.defaultActiveMenu,
    initialActiveMenu = _ref.initialActiveMenu,
    menuElementAttrs = _ref.menuElementAttrs,
    menuHeight = _ref.menuHeight,
    menuWidth = _ref.menuWidth,
    menus = _ref.menus,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? {
      back: 'Back',
      goTo: 'Go to'
    } : _ref$messages,
    offsetFn = _ref.offsetFn,
    onActiveChange = _ref.onActiveChange,
    _ref$onSearchValueCha = _ref.onSearchValueChange,
    onSearchValueChange = _ref$onSearchValueCha === void 0 ? function () {} : _ref$onSearchValueCha,
    renderMenuOnClick = _ref.renderMenuOnClick,
    searchable = _ref.searchable,
    searchProps = _ref.searchProps,
    _ref$searchValue = _ref.searchValue,
    searchValue = _ref$searchValue === void 0 ? '' : _ref$searchValue,
    spritemap = _ref.spritemap,
    trigger = _ref.trigger,
    _ref$triggerIcon = _ref.triggerIcon,
    triggerIcon = _ref$triggerIcon === void 0 ? null : _ref$triggerIcon;
  var _useState = (0, _react.useState)(defaultActiveMenu !== null && defaultActiveMenu !== void 0 ? defaultActiveMenu : initialActiveMenu),
    _useState2 = _slicedToArray(_useState, 2),
    activeMenu = _useState2[0],
    setActiveMenu = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    direction = _useState4[0],
    setDirection = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    history = _useState6[0],
    setHistory = _useState6[1];
  var triggerElementRef = (0, _react.useRef)(null);
  var _useInteractionFocus = (0, _shared.useInteractionFocus)(),
    isFocusVisible = _useInteractionFocus.isFocusVisible;
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultActive',
      defaultValue: defaultActive,
      handleName: 'onActiveChange',
      name: 'active',
      onChange: onActiveChange,
      value: externalActive
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    active = _useControlledState2[0],
    setActive = _useControlledState2[1];
  var focusHistory = (0, _react.useRef)([]);
  var innerRef = (0, _react.useRef)(null);
  var menuIds = Object.keys(menus);
  var Wrap = footerContent ? 'form' : _react.default.Fragment;
  (0, _react.useEffect)(function () {
    if (!isFocusVisible()) {
      return;
    }
    if (innerRef.current) {
      if (direction === 'prev') {
        var _focusHistory$current = focusHistory.current.slice(-1),
          _focusHistory$current2 = _slicedToArray(_focusHistory$current, 1),
          previous = _focusHistory$current2[0];
        focusHistory.current = focusHistory.current.slice(0, focusHistory.current.length - 1);
        previous === null || previous === void 0 ? void 0 : previous.focus();
      } else {
        var itemEl = innerRef.current.querySelector('.drilldown-current a.dropdown-item, .drilldown-current button.dropdown-item');
        focusHistory.current = [].concat(_toConsumableArray(focusHistory.current), [document.activeElement]);
        itemEl === null || itemEl === void 0 ? void 0 : itemEl.focus();
      }
    }
  }, [activeMenu, direction, innerRef, focusHistory, menus]);
  var onBack = (0, _react.useCallback)(function () {
    var _history$slice = history.slice(-1),
      _history$slice2 = _slicedToArray(_history$slice, 1),
      parent = _history$slice2[0];
    setHistory(history.slice(0, history.length - 1));
    setDirection('prev');
    setActiveMenu(parent.id);
  }, [history]);
  var onForward = (0, _react.useCallback)(function (label, id) {
    setHistory(function (history) {
      return [].concat(_toConsumableArray(history), [{
        id: activeMenu,
        title: label
      }]);
    });
    setDirection('next');
    setActiveMenu(id);
  }, [activeMenu]);
  var onClose = (0, _react.useCallback)(function () {
    var _triggerElementRef$cu;
    setActive(false);
    (_triggerElementRef$cu = triggerElementRef.current) === null || _triggerElementRef$cu === void 0 ? void 0 : _triggerElementRef$cu.focus();
  }, []);
  var hasLeftSymbols = (0, _react.useMemo)(function () {
    return menus[activeMenu] ? (0, _Items.findNested)(menus[activeMenu], 'symbolLeft') : false;
  }, [activeMenu, menus]);
  return /*#__PURE__*/_react.default.createElement(_DropDown.default, {
    active: active,
    alignmentByViewport: alignmentByViewport,
    alignmentPosition: alignmentPosition,
    className: className,
    containerElement: containerElement,
    hasLeftSymbols: hasLeftSymbols,
    hasRightSymbols: true,
    menuElementAttrs: _objectSpread(_objectSpread({}, menuElementAttrs), {}, {
      className: (0, _classnames.default)(menuElementAttrs === null || menuElementAttrs === void 0 ? void 0 : menuElementAttrs.className, 'drilldown')
    }),
    menuHeight: menuHeight,
    menuWidth: menuWidth,
    offsetFn: offsetFn,
    onActiveChange: function onActiveChange(value) {
      if (!active) {
        setActiveMenu(defaultActiveMenu);
        focusHistory.current = [];
        setHistory([]);
        setDirection('prev');
      }
      setActive(value);
    },
    renderMenuOnClick: renderMenuOnClick,
    trigger: /*#__PURE__*/_react.default.cloneElement(trigger, {
      ref: function ref(node) {
        if (node) {
          triggerElementRef.current = node;
          // Call the original ref, if any.
          var ref = trigger.ref;
          if (typeof ref === 'function') {
            ref(node);
          }
        }
      }
    }),
    triggerIcon: triggerIcon
  }, /*#__PURE__*/_react.default.createElement(_Items.ClayDropDownContext.Provider, {
    value: {
      close: onClose,
      messages: messages,
      onForward: onForward
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "drilldown-inner",
    ref: innerRef
  }, menuIds.map(function (menuKey) {
    var items = menus[menuKey].map(function (_ref2) {
      var label = _ref2.label,
        title = _ref2.title,
        item = _objectWithoutProperties(_ref2, _excluded);
      return _objectSpread(_objectSpread({}, item), {}, {
        label: label || title
      });
    });
    var header = activeMenu === menuKey && !!history.length ? history.slice(-1)[0].title : undefined;
    var initialClasses = (0, _classnames.default)('transitioning', {
      'drilldown-prev-initial': direction === 'prev'
    });
    var active = activeMenu === menuKey;
    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      "aria-hidden": !active,
      className: (0, _classnames.default)('drilldown-item', {
        'drilldown-current': active
      }),
      classNames: {
        enter: initialClasses,
        enterActive: "drilldown-transition drilldown-".concat(direction, "-active"),
        exit: initialClasses,
        exitActive: "drilldown-transition drilldown-".concat(direction, "-active")
      },
      in: active,
      key: menuKey,
      timeout: 250
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "drilldown-item-inner"
    }, header && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-header",
      onClick: onBack
    }, /*#__PURE__*/_react.default.createElement(_button.ClayButtonWithIcon, {
      "aria-label": messages.back,
      className: "component-action dropdown-item-indicator-start",
      onClick: onBack,
      spritemap: spritemap,
      symbol: "angle-left",
      tabIndex: -1,
      title: messages.back
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "dropdown-item-indicator-text-start"
    }, header)), /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-divider"
    })), defaultActiveMenu === menuKey ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, helpText && /*#__PURE__*/_react.default.createElement(_Help.default, null, helpText), searchable && /*#__PURE__*/_react.default.createElement(_Search.default, _extends({}, searchProps, {
      onChange: onSearchValueChange,
      spritemap: spritemap,
      value: searchValue
    })), /*#__PURE__*/_react.default.createElement(Wrap, null, footerContent ? /*#__PURE__*/_react.default.createElement("div", {
      className: "inline-scroller"
    }, /*#__PURE__*/_react.default.createElement(_Items.DropDownItems, {
      items: items,
      spritemap: spritemap
    })) : /*#__PURE__*/_react.default.createElement(_Items.DropDownItems, {
      items: items,
      spritemap: spritemap
    }), caption && /*#__PURE__*/_react.default.createElement(_Caption.default, null, caption), footerContent && /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-section",
      role: "presentation"
    }, footerContent))) : /*#__PURE__*/_react.default.createElement(_Items.DropDownItems, {
      items: items,
      spritemap: spritemap
    })));
  }))));
};
ClayDropDownWithDrilldown.displayName = 'ClayDropDownWithDrilldown';